import React from 'react';
import { useSelector } from 'react-redux';
import { getDatasourceName } from '@/store-selectors';

export const useUpdatePageTitleWithDatasourceName = () => {
  const datasourceName = useSelector(getDatasourceName);

  React.useEffect(() => {
    if (datasourceName) {
      document.title = `Trevor.io | ${datasourceName}`;
    }
  }, [datasourceName]);
};
